import React from 'react';

import Loader from '../../../core/components/Loader.tsx';
import classnames from '../../../core/utils/classnames.tsx';

export interface VoiceAgentBusyOverlayProps {
    title: string;
    subtitle?: string;
    // cover the nearest positioned ancestor instead of the viewport — for actions owned by a dialog
    isContained?: boolean;
}

// Blocks the screen while a long-running action is in flight. The full-screen variant sits above the modal
// layer (core Modal uses z-[21000]) so it still covers everything when started from inside a dialog.
const VoiceAgentBusyOverlay = ({ title, subtitle, isContained }: VoiceAgentBusyOverlayProps) => (
    <div
        className={classnames(
            'inset-0 flex flex-col items-center justify-center gap-4 bg-surface-weak/85 backdrop-blur-sm',
            isContained ? 'absolute z-50 rounded-xl' : 'fixed z-[21100]'
        )}
    >
        <Loader className="w-14" />
        <div className="flex flex-col items-center gap-1 px-6 text-center">
            <span className="font-semibold text-content-strong">{title}</span>
            {subtitle && <span className="text-sm text-content-medium">{subtitle}</span>}
        </div>
    </div>
);

export default VoiceAgentBusyOverlay;
